export const services = [
  {
    id: 1,
    icon: 'ri-drop-line',
    title: 'Bathroom Remodels',
    description: 'Transform your bathroom into a luxurious retreat with our expert remodeling services, from modern fixtures to custom tile work.'
  },
  {
    id: 2,
    icon: 'ri-restaurant-line',
    title: 'Kitchen Remodels',
    description: 'Create the kitchen of your dreams with custom cabinetry, countertops, and layouts designed for functionality and style.'
  },
  {
    id: 3,
    icon: 'ri-paint-brush-line',
    title: 'Interior Painting',
    description: 'Refresh your living spaces with professional interior painting services using premium paints and expert techniques.'
  },
  {
    id: 4,
    icon: 'ri-home-4-line',
    title: 'Exterior Painting',
    description: 'Protect and beautify your home\'s exterior with durable, weather-resistant paint applications that last for years.'
  },
  {
    id: 5,
    icon: 'ri-layout-grid-line',
    title: 'Flooring Installation',
    description: 'Expert installation of hardwood, tile, laminate, and vinyl flooring to enhance the beauty and value of your home.'
  },
  {
    id: 6,
    icon: 'ri-tools-line',
    title: 'Drywall Work',
    description: 'Professional drywall installation, repair, and finishing services for smooth, flawless walls and ceilings.'
  }
];
